(function (LanguageSwitcher, $, undefined) {

	var bindUIActions = function () {  

		$(document).on('click', '.language-switcher__button', function () {
			var parent = $(this).parent();
			parent.toggleClass('open');
		});
	};

	LanguageSwitcher.init = function () {
		bindUIActions();
	};
 
}(window.LanguageSwitcher = window.LanguageSwitcher || {}, jQuery));
